module.exports = __webpack_public_path__ + "img/index-interact.39937e4c.png";